import Card from '@mui/material/Card';
import {Button, CardActions, CardContent, Chip, Stack} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

const WHITE_PLACEHOLDER_IMAGE = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9"><rect width="16" height="9" fill="white"/></svg>';

export default function AstroCompo({tile, index, accent = '#2b6cb0'}) {

    const [imageIndex, setImageIndex] = React.useState(0);
    const imageCount = tile.images?.length || 0;
    const currentImage = tile.images?.[imageIndex];
    const imageUrl = currentImage?.url || WHITE_PLACEHOLDER_IMAGE;
    const imageDate = currentImage?.year ? `${currentImage.year}${currentImage.month ? `-${currentImage.month}` : ''}` : 'n/a';

    return (
        <Card
            key={index}
            variant="outlined"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                borderRadius: 3,
                borderColor: '#d9e2ef',
                overflow: 'hidden',
                backgroundColor: '#fff',
                transition: 'transform 140ms ease, box-shadow 140ms ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 24px rgba(12, 30, 63, 0.12)'
                }
            }}
        >
            <Box
                component="a"
                href={imageCount > 0 ? imageUrl : undefined}
                target="_blank"
                rel="noreferrer"
                sx={{display: 'block', textDecoration: 'none'}}
            >
                <Box
                    component="img"
                    src={imageUrl}
                    alt={`${tile.name} ${tile.description || ''}`.trim()}
                    sx={{
                        width: '100%',
                        height: 260,
                        objectFit: 'cover',
                        backgroundColor: '#fff'
                    }}
                />
            </Box>

            <CardContent sx={{pb: 1.5}}>
                <Stack spacing={1}>
                    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap'}}>
                        <Typography variant="h6" sx={{fontSize: '1rem', fontWeight: 700}}>
                        {tile.name}
                    </Typography>
                        {tile.description && (
                            <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                ({tile.description})
                            </Typography>
                        )}
                    </Box>

                    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                        <Chip label={`Type: ${tile.type || 'n/a'}`} size="small" sx={{borderColor: accent, color: accent}} variant="outlined"/>
                        <Chip label={`Catalog: ${tile.catalog || 'n/a'}`} size="small" variant="outlined"/>
                        <Chip label={`Image ${Math.min(imageIndex + 1, Math.max(imageCount, 1))}/${Math.max(imageCount, 1)}`} size="small" variant="outlined"/>
                        <Chip label={`Date: ${imageDate}`} size="small" variant="outlined"/>
                    </Stack>
                </Stack>
            </CardContent>

            <CardActions sx={{display: 'flex', justifyContent: 'space-between', px: 2, pb: 2}}>
                <Button
                    variant="outlined"
                    disabled={imageCount <= 1 || imageIndex === 0}
                    size="small"
                    onClick={() => {
                        setImageIndex(imageIndex - 1);
                    }}
                >
                    Previous
                </Button>

                <Button
                    variant="outlined"
                    disabled={imageCount <= 1 || imageIndex === imageCount - 1}
                    size="small"
                    onClick={() => {
                        setImageIndex(imageIndex + 1);
                    }}
                >
                    Next
                </Button>
            </CardActions>
        </Card>
    );
}